export default __webpack_public_path__ + "assets/models/15f66c7477dedfc85c120cefd902affd.glb";